import { ChevronLeft } from "@mui/icons-material";
import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Icon from "../../../../components/HOC/Icon";
import { enqueueSnackbar } from "notistack";
import getChangeRequest from "../../../../controllers/booking/postTicketing/change/getChangeRequest";
import getRefundTicketRequest from "../../../../controllers/booking/postTicketing/refund/getRefundTicketRequest";
import getVoidTicketRequest from "../../../../controllers/booking/postTicketing/void/getVoidTicketRequest";

function VoidConfirmationHeader({ data, setData, loading, setLoading }) {
  const navigate = useNavigate();
  const { id } = useParams();

  const loadData = async (reload) => {
    if (!id) return;
    if (data && !reload) return;
    setLoading?.(true);
    const res = await getVoidTicketRequest(id)?.finally(() =>
      setLoading?.(false)
    );
    if (res?.return) {
      const order = res?.data;
      if (order?.selectedOffer) {
        order.selectedOffer = JSON.parse(order?.selectedOffer);
      }
      setData(order);
    } else {
      enqueueSnackbar(
        res?.msg || "Something went wrong. Please try again later.",
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    loadData();
  }, [id]);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex justify-between items-center sm:mb-4 bg-[#F7F9FA] py-2 shadow-md w-full">
      <div className="flex items-center gap-2 lg:gap-4">
        <div className="p-2 border-r cursor-pointer" onClick={handleBack}>
          <ChevronLeft />
        </div>
        <span className="text-smC lg:text-lg font-bold">Void Details</span>
        {!loading ? (
          <Icon
            icon="mdi:reload"
            className="cursor-pointer text-theme1"
            onClick={() => loadData(true)}
          />
        ) : (
          <></>
        )}
      </div>
      <button
        className="bg-white text-black px-4 py-2 rounded-md border mr-3"
        onClick={handleBack}
      >
        Back
      </button>
    </div>
  );
}

export default VoidConfirmationHeader;
